module.exports = __webpack_public_path__ + "static/media/app_gallery_badge_ru_color_40.6956b017.svg";